document.addEventListener('DOMContentLoaded', function(){
    let possibleCheckBoxLocation = document.querySelector('.template-product .variant-outline-style');
    let possibleSelectLocation = document.querySelector('.template-product .product-parameters');

    if (!possibleCheckBoxLocation || !possibleSelectLocation) {
        return;
    }

    if(
        possibleCheckBoxLocation
        && possibleSelectLocation
        && possibleCheckBoxLocation.innerHTML.includes('Maat:')
        && possibleSelectLocation.innerHTML.includes('Maat:')
    ) {
        possibleCheckBoxLocation.remove();
    } else {
        possibleCheckBoxLocation.classList.remove('hidden');
    }
});
